module.exports = __webpack_public_path__ + "img/lineup12@2x.5246d685.png";